

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#4C4C4C',
    },
    secondary: {
      main: '#F34213',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      letterSpacing: "-.04em",
      lineHeight: 1.16,

      fontWeight: 700,
      '@media (max-width:600px)': {
        fontSize: '3.5rem',
      },
    },
    h2: {
      letterSpacing: "-.032em",
      fontSize: "3.9rem",
      fontWeight: 700,

    },
    h3: {
      lineHeight: 1.26,
      letterSpacing: "-.032em",

      fontWeight: 600,
      '@media (max-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h4: {
      lineHeight: 1.36,
      letterSpacing: "-.024em",

      fontWeight: 600
    },

    body1: {
      letterSpacing: "-.014em",
      lineHeight: "23.1px",
      fontSize: "15px",
      fontWeight: 300,
      fontFamily: 'Poppins, sans-serif',


    },
    body2: {
      letterSpacing: "-.012em",
      lineHeight: 1.5,
      fontSize: "1.6rem",

      opacity: 0.9

    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          height: "1.7rem",
          '&.Mui-selected': {
            backgroundColor: "transparent",
            color: '#4C4C4C',
            border : "1px solid #4C4C4C",
            borderRadius : 3
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor : "rgb(245,245,245)",
          '&.Mui-focused': {
            borderColor: '#4C4C4C',
          },
        },
      },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            "&:hover": {
              backgroundColor: "inherit",
              color: "inherit"
            }
          },
        },
      },
    },
  };